/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const UNUSED_ESPOT_KEYS = {
	activityPriority: true,
	attachementExternalId: true,
	attachementId: true,
	attachementStoreId: true,
	AttachmentDescription: true,
	attachmentReferenceId: true,
	contentClickAction: true,
	defaultContentDisplaySequence: true,
	MarketingContentDescription: true,
	nextTimeLimit: true,
	resourceId: true,
	resourceName: true,
};
